"use client";

import Link from "next/link";
import { Camera } from "lucide-react";
import { useLanguage } from "@/lib/useLanguage";

type Props = {
  variant?: "banner" | "compact";
  className?: string;
};

export function CommunityCaptureCta({ variant = "banner", className = "" }: Props) {
  const { t } = useLanguage();
  const c = t.communityCta;

  if (variant === "compact") {
    return (
      <p className={`text-xs text-gray-600 dark:text-gray-400 ${className}`}>
        {c?.compactPrefix ?? "¿Has visto un menú?"}{" "}
        <Link href="/download" className="font-semibold text-accentDark dark:text-accent hover:underline">
          {c?.compactLink ?? "Súbelo en 10 segundos"}
        </Link>{" "}
        {c?.compactSuffix ?? "y ayuda a mantener frescos los menús cerca de ti."}
      </p>
    );
  }

  return (
    <div
      className={`rounded-xl border border-orange-200/80 dark:border-orange-900/50 bg-gradient-to-r from-orange-50 to-amber-50 dark:from-orange-950/40 dark:to-amber-950/30 p-4 ${className}`}
    >
      <div className="flex gap-3 items-start">
        <div className="shrink-0 rounded-lg bg-orange-500/15 p-2">
          <Camera className="w-5 h-5 text-orange-600 dark:text-orange-400" aria-hidden />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-gray-900 dark:text-white">
            {c?.bannerTitle ?? "¿Has visto un menú? Súbelo en 10 segundos."}
          </p>
          <p className="text-xs text-gray-600 dark:text-gray-400 mt-1 leading-relaxed">
            {c?.bannerBody ??
              "Con la app de MenúHunter puedes ayudar a mantener actualizados los menús del día en tu ciudad — empezamos en Barcelona. Sin promesas de pago: solo comunidad."}
          </p>
          <Link
            href="/download"
            className="inline-flex mt-2 text-sm font-semibold text-orange-700 dark:text-orange-300 hover:underline"
          >
            {c?.bannerLink ?? "Descargar la app →"}
          </Link>
        </div>
      </div>
    </div>
  );
}
